import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';

import Rating from '../../Rating';

import type { Provider } from 'Plan-Types';

import useTextParser from 'favoriteList/hooks/useTextParser';
import styles from './providerInformationCard.module.scss';

type Props = {
  provider: Provider;
};

const ProviderInformationCard = (props: Props) => {
  const { provider } = props;
  const deviceType = useDeviceType();
  const isSP = deviceType === MOBILE_SCREEN;
  const textParser = useTextParser({
    originalText: provider.hotelName,
  });
  const formattedHotelName = textParser.formattedText;

  return (
    <section className={styles.hotelInformationSectionContainer}>
      <div className={styles.hotelTitleContainer}>
        <h2>
          <a className={styles.hotelNameTitle} href={provider.hotelInfoUrl}>
            {formattedHotelName}
          </a>
        </h2>
        <p className={styles.departureNameText}>{provider.detailAreaName}</p>
      </div>
      <div className={styles.hotelRatingContainer}>
        {provider.ratingInfo.count &&
        provider.ratingInfo.average &&
        provider.ratingInfo.count > 0 &&
        provider.ratingInfo.average > 0 ? (
          <Rating
            rating={provider.ratingInfo.average}
            numReviews={provider.ratingInfo.count}
            type={isSP ? 'SP' : 'PC'}
          />
        ) : null}
      </div>
    </section>
  );
};

export default ProviderInformationCard;
